import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const { user, loading, sessionChecked } = useAuth();

  useEffect(() => {
    // Only redirect after session check is complete AND user is definitely not logged in
    if (sessionChecked && !loading && !user) {
      navigate('/login', { replace: true });
    }
  }, [user, loading, sessionChecked, navigate]);

  // Show loading while checking session or loading auth state
  if (loading || !sessionChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F4] dark:bg-stone-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto"></div>
          <p className="mt-4 text-stone-600 dark:text-stone-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return children({ user });
}